import React from "react";

import DropDown, { DropDownOption } from "../inputform/DropDown";
import { SpreadsheetColumnDefinition } from "../../types/data/SpreadsheetConfiguration";

interface ImportGridHeaderCellProps {
    column: SpreadsheetColumnDefinition;

    columnChanged: (column: SpreadsheetColumnDefinition, value: string) => void;
}

interface ImportGridHeaderCellState {}

class ImportGridHeaderCell extends React.Component<
    ImportGridHeaderCellProps,
    ImportGridHeaderCellState
> {
    buildFieldOptions(
        options: Array<SpreadsheetColumnDefinition>,
    ): DropDownOption[] {
        return options.map((option, index) => ({
            text: option.Name,
            value: option.Field,
            order: index + 1,
        }));
    }

    render(): React.ReactNode {
        return (
            <th className="title">
                <DropDown
                    noType={true}
                    value={this.props.column.Target}
                    options={this.buildFieldOptions(this.props.column.Options)}
                    onChange={value =>
                        this.props.columnChanged(this.props.column, value)
                    }
                />
            </th>
        );
    }
}

export default ImportGridHeaderCell;
